import { SEO } from '../components/seo/SEO';
import { Hero } from '../components/Hero';
import { FeaturedPetsHome } from '../components/home/FeaturedPetsHome';
import { AdoptionProcess } from '../components/AdoptionProcess';
import { SuccessStories } from '../components/SuccessStories';
import { VolunteerCTA } from '../components/VolunteerCTA';
import { Contact } from '../components/Contact';
import { DonationBanner } from '../components/DonationBanner';
import { EmergencyFundraiser } from '../components/home/EmergencyFundraiser';
import { EmergencyHelp } from '../components/EmergencyHelp';
import { QuickDonation } from '../components/home/QuickDonation';
import { DonationMethods } from '../components/home/DonationMethods';
import { UrgentNeedsBanner } from '../components/home/UrgentNeedsBanner';
import { getOrganizationSchema, getWebsiteSchema } from '../lib/jsonLd';

export function HomePage() {
  // Combine multiple schemas for the homepage
  const jsonLd = {
    '@context': 'https://schema.org',
    '@graph': [
      getOrganizationSchema(),
      getWebsiteSchema(),
      {
        '@type': 'WebPage',
        'name': 'Fundacja Znajdki - Adoptuj psa lub kota',
        'description': 'Pomagamy bezdomnym zwierzętom znaleźć nowy dom. Adoptuj psa lub kota, zostań wolontariuszem, wspieraj naszych podopiecznych finansowo. Fundacja Znajdki - KRS 0000437387.',
        'url': 'https://znajdki.pl'
      }
    ]
  };

  return (
    <>
      <SEO 
        title="Fundacja Znajdki - Adoptuj psa lub kota"
        description="Pomagamy bezdomnym zwierzętom znaleźć nowy dom. Adoptuj psa lub kota, zostań wolontariuszem, wspieraj naszych podopiecznych finansowo. Fundacja Znajdki - KRS 0000437387."
        url="/"
        image="/images/animals/fundacja-znajdki-zwierzeta-001.webp"
        jsonLd={jsonLd}
      />
      <Hero />
      <UrgentNeedsBanner />
      <FeaturedPetsHome />
      <DonationBanner />
      <EmergencyFundraiser />
      {/* <MonthlyGoalTracker /> */}
      <AdoptionProcess />
      <EmergencyHelp />
      <QuickDonation />
      <SuccessStories />
      {/* <DonationCounter /> */}
      <DonationMethods />
      <VolunteerCTA />
      {/* <Newsletter /> */}
      <Contact />
    </>
  );
}